import { Rotas } from "constants/EnumRotas";
import { api } from "constants/RotasAPI";
import usePost from "hooks/usePost";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { queryClient } from "shared/util/queryClient";
import { RequestCriarProcessoJudicialDTO } from "types/request/RequestCriarProcessoJudicial";

export const usePostCriarProcessoJudicial = () => {
  const navigate = useNavigate();
  const onSuccess = (response: any) => {
    toast.success("Processo criado com sucesso!");
    queryClient.invalidateQueries(["processos-judiciais"]);
    navigate(Rotas.PROCESSOS_JUDICIAIS, {
      state: { processoJudicialId: response.data.id, unidadeId: response.data.unidadeId },
    });
    return response;
  };

  return usePost<RequestCriarProcessoJudicialDTO>({
    url: api.processosJudiciais.postProcessoJudicial,
    onSuccess,
  });
};
